import { forwardRef } from "react";

import { cn } from "../lib/cn";

export interface GlassProps extends React.HTMLAttributes<HTMLElement> {
  active?: boolean;
  shimmer?: boolean;
  as?: "div" | "section" | "article";
}

export const Glass = forwardRef<HTMLElement, GlassProps>(function Glass(
  { active, shimmer, className, as: Tag = "div", children, ...props },
  ref,
) {
  return (
    <Tag
      ref={ref as React.Ref<HTMLDivElement>}
      className={cn(
        "relative rounded-sm border transition-all duration-300",
        "border-[var(--glass-border)] bg-[var(--glass-bg)]",
        "[backdrop-filter:var(--glass-blur)]",
        "[box-shadow:var(--glass-shadow)]",
        "hover:-translate-y-1 hover:border-[var(--glass-hover-border)] hover:bg-[var(--glass-hover-bg)] hover:[box-shadow:var(--glass-hover-shadow)]",
        active &&
          "border-[var(--glass-active-border)] [box-shadow:var(--glass-active-shadow)]",
        shimmer && "overflow-hidden",
        className,
      )}
      {...props}
    >
      {shimmer && (
        <div
          className="pointer-events-none absolute inset-x-0 top-0 h-px opacity-0 transition-opacity duration-300 group-hover:opacity-100"
          style={{
            background:
              "linear-gradient(90deg, transparent, var(--color-gold), transparent)",
          }}
          aria-hidden="true"
        />
      )}
      {children}
    </Tag>
  );
});
